import React from 'react';
import PropTypes from 'prop-types';
import {SearchLineIcon} from '~library/svg/SearchLineIcon';
import {pebble} from '~libSass/base/_exports.sass';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';

const NumGuests = (props) => (
  <div className="wic__num-guests-wrapper">
    <div
      className={`wic__num-guests ${props.status.toLowerCase().replaceAll(' ', '_')}`}
      data-qa-id={`${props.status.toLowerCase().replaceAll(' ', '-')}-count`}
      data-qa-value={props.count}
    >
      <Typography variant="paragraph3" classNames="wic__guest-count">
        {props.count}
      </Typography>
    </div>
    <Typography variant="paragraph3">{props.status}</Typography>
  </div>
);

NumGuests.propTypes = {
  status: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

export const WhoIsComingHeader = (props) => (
  <div className="view-invitation__who-is-coming-header">
    <div className="wic__guest-counts">
      <NumGuests status="Yes" count={props.yes} />
      {props.maybe !== undefined && <NumGuests status="Maybe" count={props.maybe} />}
      <NumGuests status="No" count={props.no} />
      <NumGuests status="No Reply" count={props.no_reply} />
    </div>
    <div className="wic__guest-actions">
      <Input
        data-qa-id="search-guests"
        value={props.query}
        onChange={(e) => props.onQueryChange(e.target.value)}
        startAdornment={<SearchLineIcon ratio={0.5} color={pebble} />}
        placeholder="Search guests"
      />
      {/* TODO: Restore 'Add Guests' */}
      {/* {props.allowAddGuests && !props.preview && (
        <a
          className="button primary large"
          data-qa-id="add-guests"
          href={props.addGuestsUrl}
        >
          Add Guests
        </a>
      )} */}
    </div>
  </div>
);

WhoIsComingHeader.propTypes = {
  yes: PropTypes.number.isRequired,
  maybe: PropTypes.number,
  no: PropTypes.number.isRequired,
  no_reply: PropTypes.number.isRequired,
  query: PropTypes.string,
  onQueryChange: PropTypes.func,
  allowAddGuests: PropTypes.bool,
  addGuestsUrl: PropTypes.string,
  preview: PropTypes.bool,
};
